if (!window.viraCheckout) {
      (function () {
        var CART_JSON = '/cart.json';
        var YAMPI_CART_API = 'https://api.dooki.com.br/v2/public/shopify/cart';
        var TIMEOUT_MS = 8000;

        var cache = { url: null, sig: null };
        var prefetching = false;
        var busy = false;
        var debounceTimer = null;

        function setAviso(show) {
          var el = document.querySelector('[data-vira-checkout-aviso]');
          if (el) el.hidden = !show;
        }

        function hideYampiLoaderSafe() {
          var loader = document.querySelector('.yampi-loader');
          if (loader) loader.style.display = 'none';
        }

        function setLoading(button, on) {
          if (!button) return;
          if (on) {
            if (!button.dataset.originalLabel) {
              button.dataset.originalLabel = button.textContent.trim();
            }
            var label = button.dataset.loadingLabel;
            if (label) button.textContent = label;
            button.classList.add('is-vira-loading');
            button.setAttribute('aria-busy', 'true');
          } else {
            if (button.dataset.originalLabel) {
              button.textContent = button.dataset.originalLabel;
            }
            button.classList.remove('is-vira-loading');
            button.removeAttribute('aria-busy');
          }
        }

        function signature(cart) {
          if (!cart || !cart.items) return null;
          var lines = cart.items
            .map(function (item) {
              return item.key + 'x' + item.quantity;
            })
            .join(',');
          return cart.item_count + '|' + cart.total_price + '|' + lines;
        }

        function getCart() {
          return fetch(CART_JSON, {
            headers: { Accept: 'application/json' },
            cache: 'no-store',
          }).then(function (response) {
            return response.json();
          });
        }

        // Vira 15/10/2026: trava do produto-oferta do upsell (sections/vira-upsell-modal.liquid).
        // A oferta entra com a propriedade oculta _vira_oferta. Ela só vale junto de outro produto
        // e com quantidade 1: sozinha no carrinho é removida; quantidade maior volta para 1.
        function linhaOferta(item) {
          return !!(item && item.properties && item.properties._vira_oferta);
        }

        function ajustarOferta(cart) {
          if (!cart || !cart.items) return Promise.resolve(cart);

          var ofertas = cart.items.filter(linhaOferta);
          if (!ofertas.length) return Promise.resolve(cart);

          var temOutro = cart.items.some(function (item) {
            return !linhaOferta(item);
          });
          var updates = {};
          var mudou = false;

          ofertas.forEach(function (item, indice) {
            var qtd = temOutro && indice === 0 ? 1 : 0;
            if (item.quantity !== qtd) {
              updates[item.key] = qtd;
              mudou = true;
            }
          });

          if (!mudou) return Promise.resolve(cart);

          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates }),
          })
            .then(function (response) {
              return response.json();
            })
            .then(function (novo) {
              // source cart-items-component: a gaveta se redesenha sem abrir sozinha.
              document.dispatchEvent(
                new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: novo,
                    sourceId: 'vira-oferta',
                    data: { source: 'cart-items-component', itemCount: novo.item_count },
                  },
                })
              );
              return novo;
            });
        }

        window.viraAjustarOferta = ajustarOferta;

        function askYampi(cart) {
          return fetch(YAMPI_CART_API, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest',
            },
            body: JSON.stringify({
              shop: window.location.host,
              cart_payload: cart,
            }),
          }).then(function (response) {
            return response.json();
          });
        }

        function withUtms(url) {
          try {
            return typeof ymp_getUrlWithUtms === 'function' ? ymp_getUrlWithUtms(url) : url;
          } catch (e) {
            return url;
          }
        }

        function clearCache() {
          cache = { url: null, sig: null };
        }

        function prefetch() {
          if (prefetching) return;
          prefetching = true;

          getCart()
            .then(ajustarOferta)
            .then(function (cart) {
              if (!cart || !cart.item_count) {
                clearCache();
                return null;
              }
              var sig = signature(cart);
              return askYampi(cart).then(function (resp) {
                if (resp && resp.checkout_direct_url) {
                  cache = { url: resp.checkout_direct_url, sig: sig };
                } else {
                  clearCache();
                }
              });
            })
            .catch(clearCache)
            .then(
              function () {
                prefetching = false;
              },
              function () {
                prefetching = false;
              }
            );
        }

        function schedulePrefetch() {
          clearCache();
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(prefetch, 600);
        }

        window.viraCheckout = function (button) {
          if (busy) return;

          button = button || document.querySelector('[data-vira-checkout-button]');
          setAviso(false);
          busy = true;
          setLoading(button, true);

          function fail() {
            clearTimeout(window.viraCheckoutTimer);
            hideYampiLoaderSafe();
            setLoading(button, false);
            setAviso(true);
            busy = false;
          }

          clearTimeout(window.viraCheckoutTimer);
          window.viraCheckoutTimer = setTimeout(fail, TIMEOUT_MS);

          getCart()
            .then(ajustarOferta)
            .then(function (cart) {
              if (!cart || !cart.item_count) throw new Error('carrinho vazio');

              var sig = signature(cart);

              if (cache.url && cache.sig && cache.sig === sig) {
                window.location.href = withUtms(cache.url);
                return null;
              }

              return askYampi(cart).then(function (resp) {
                if (!resp || !resp.checkout_direct_url) throw new Error('sem url de checkout');
                window.location.href = withUtms(resp.checkout_direct_url);
              });
            })
            .catch(fail);
        };

        // Vira 15/10/2026: o checkout antigo (yampiClick e o redirecionamento da página /cart)
        // manda o carrinho à Yampi via postAjax; aqui ele passa pela mesma trava da oferta.
        (function travarOfertaNoPostAjax(tentativas) {
          if (typeof window.postAjax !== 'function') {
            if (tentativas < 80) setTimeout(travarOfertaNoPostAjax, 100, tentativas + 1);
            return;
          }
          if (window.postAjax.__viraTravaOferta) return;

          var original = window.postAjax;
          var travado = function (url, data, success) {
            var self = this;
            var args = arguments;
            if (typeof url !== 'string' || url.indexOf('dooki.com.br') === -1 || typeof data !== 'string') {
              return original.apply(self, args);
            }

            var corpo;
            try {
              corpo = JSON.parse(data);
            } catch (e) {
              return original.apply(self, args);
            }

            ajustarOferta(corpo.cart_payload)
              .then(function (cart) {
                corpo.cart_payload = cart;
                original.call(self, url, JSON.stringify(corpo), success);
              })
              .catch(function () {
                original.apply(self, args);
              });
            return null;
          };

          travado.__viraTravaOferta = true;
          window.postAjax = travado;
        })(0);

        document.addEventListener('cart:update', schedulePrefetch);
        window.addEventListener('pageshow', schedulePrefetch);

        if (document.readyState === 'complete') {
          schedulePrefetch();
        } else {
          window.addEventListener('load', schedulePrefetch, { once: true });
        }
      })();
    }
